module.exports = __webpack_public_path__ + "img/poultry.a4093494.svg";